import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import { getUTCDate } from 'src/utils/date';
import format from 'date-fns/format';
import linkUtils from 'src/utils/linkUtils';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import { truncate } from 'underscore.string';
import Card from 'src/components/card';

const CommunityHomeEvents = ({ events }) => (
  <Card
    title={i18n.t('Events')}
  >
    {events.map(communityEvent => {
      const eventDate = getUTCDate(communityEvent.date);
      const eventName = truncate(communityEvent.name, 60);
      return (
        <div className="community__widget__event" key={communityEvent.id} >
          <div className="community__widget__event__calendar">
            <div className="community__widget__event__calendar-page">
              {format(eventDate, 'dd')}<br />{format(eventDate, 'MMM')}
            </div>
          </div>
          <div className="community__widget__event__content">
            <div className="community__widget__event__content-title">
              {communityEvent.url
                ? (
                  <a
                    href={linkUtils.prepLink(communityEvent.url)}
                    target="_blank"
                    onClick={() => {
                      trackFootfallEvent(footfallEventTypes.CLICKED, {
                        clickType: 'community-event',
                        clickMetadata: { section: 'community-side-bar' },
                      });
                    }}
                  >
                    {eventName}{' '}
                    {communityEvent.url && <span className="icon icon-link-ext" />}
                  </a>
                )
                : <span>{eventName}</span>}
            </div>
            <div className="community__widget__event__content-subtitle">
              {communityEvent.isDateOnly
                ? format(eventDate, 'MMMM dd, yyyy')
                : format(eventDate, 'MMMM dd, yyyy - h:mm a')}
            </div>
          </div>
        </div>
      );
    })}
  </Card>
);

CommunityHomeEvents.propTypes = {
  events: PropTypes.array.isRequired,
};

export default CommunityHomeEvents;
